<script>
	export let text = ''
</script>

<div class="lineSeparator">
	<span class="lineSeparator-text">{text}</span>
</div>
